var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/MainConnection/ConnectionCardsList/index.tsx";
import React from 'react';
import { Stack } from '@adc/parallax-component-library';
import { useConnectionCardVisibility } from 'Hooks';
import CaregiverCard from 'Components/connection/Caregiver/CaregiverCard';
import LibreDataShareCard from 'Components/connection/LibreDataShare/LibreDataShareCard';
import PartnerCard from 'Components/connection/Partner/PartnerCard';
import PracticeCard from 'Components/connection/Practice/PracticeCard';
const ConnectionCardsList = ({
  connections
}) => {
  const {
    isLibre,
    showPractice,
    showCaregiver,
    showDataShare,
    showPartner
  } = useConnectionCardVisibility();
  return /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, showPractice && /*#__PURE__*/React.createElement(PracticeCard, {
    practiceConnections: connections?.practiceConnections,
    practiceInvitations: connections?.practiceInvitations,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  }), showCaregiver && /*#__PURE__*/React.createElement(CaregiverCard, {
    caregiverInvitations: connections?.caregiverInvitations,
    caregiverConnections: connections?.caregiverConnections,
    isLibre: isLibre,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 29,
      columnNumber: 9
    }
  }), showDataShare && /*#__PURE__*/React.createElement(LibreDataShareCard, {
    dataShareConnection: connections?.libreDataShare,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 25
    }
  }), showPartner && /*#__PURE__*/React.createElement(PartnerCard, {
    partnerConnections: connections?.partnerConnections,
    partnerInvitations: connections?.partnerInvitations,
    availableCommercialAPIPartners: connections?.availableCommercialAPIPartners,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 9
    }
  }));
};
export default ConnectionCardsList;